/* 
should be a standard "export const" api that each address form has,
which returns an array for validating and normalization.

this should also be added to an array in EditEvent.svelte
and associatied with a country code, so that we can dynamically/programatically
use this api within.

for example:

import UnitedStates from "../addresses/UnitedStates.js";
// import Indonesia from "../addresses/Indonesia.js";

let countryForms = {
  "us": UnitedStates,
  // "id": Indonesia,
}

...

function ...() {
  // api.validation contains an array of object names
  // that should be validated against
  let addressValidation = countryForms[country].api.validation;
}
*/ 



module.exports = {
  
  phone: (phone) => {
    
    phone = phone.toString();
  
    let firstFour = true;
    let plen = phone.length; 
    
    while(plen > 0) {
      
      if (firstFour == true) {
        firstFour = false;
        plen -= 4;
      } else {
        plen -= 3;
      }
      
      if (plen > 0) {
        phone = phone.slice(0, plen) + '-' + phone.slice(plen);
      }
    }
    
    return phone;
      
  },
  
  
  address: (address) => {
    // this is secure, because we do some XSS filtering on save _and_ load
    return address.address + "<br>" + address.city + ", " + address.state + " " + address.zip;
  },
  
  
  // return an empty address structure
  empty: () => {
    return {
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
    }
  },
  
  
  // return an array of strings suitable for full text search
  searchIndex: () => {
    return ["usa", "united", "states", "america"];
  },
  
  
  currency: () => {
    return "$";
  },
  
}